import {
  AmbientLight,
  DirectionalLight,
  Object3D,
  PerspectiveCamera,
  Scene,
  sRGBEncoding,
  TextureLoader,
  WebGLRenderer,
  Raycaster,
  Vector2,
} from 'three';

import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';

const clamData = window.photoclammetry_data;


const mouse = new Vector2();
const raycaster = new Raycaster();

function init() {

  const container = document.getElementById('model-container');
  
  const scene = new Scene();

  // lights!
  const ambientLight = getAmbientLight(0.6);

  const intensity = 0.5;
  const directLight = new DirectionalLight(0xffffff, intensity);
  const directLight2 = new DirectionalLight(0xffffff, intensity);
  const directLight3 = new DirectionalLight(0xffffff, intensity);
  const directLight4 = new DirectionalLight(0xffffff, intensity);

  directLight.position.set(5, 10, 7.5);
  directLight2.position.set(-5, 10, -7.5);
  directLight3.position.set(5, -10, 7.5);
  directLight4.position.set(-5, -10, -7.5);

  directLight.castShadow = true;
  directLight2.castShadow = true;
  directLight3.castShadow = true;
  directLight4.castShadow = true;

  // camera!
  const fov = 45;
  const height = container.offsetHeight;
  const width = container.offsetWidth;
  const aspect = width / height;
  const near = 1;
  const far = 1000;

  const camera = new PerspectiveCamera(fov, aspect, near, far);
  camera.position.set(2.3, 0.65, 0);

  // clam!
  // set up the object loader
  const gltfLoader = new GLTFLoader();

  let model = new Object3D();

  gltfLoader.load(`${clamData['clam']['model']}`, function (gltf) {
    model = gltf.scene;

    let scaleValue;
    if (width <= 600) {
      scaleValue = 0.8;
    } else {
      scaleValue = 0.9;
    }

    model.scale.set(scaleValue, scaleValue, scaleValue);

    scene.add(model);
  });

  scene.add(ambientLight);
  scene.add(directLight);
  scene.add(directLight2);
  scene.add(directLight3);
  scene.add(directLight4);

  // action!
  // renderer
  const renderer = new WebGLRenderer({ antialias: true, alpha: true });
  renderer.shadowMap.enabled = true;
  renderer.setSize(width, height);
  renderer.outputEncoding = sRGBEncoding;
  renderer.gammaFactor = 2.2;
  renderer.physicallyCorrectLights;

  container.appendChild(renderer.domElement);

  // controls
  const controls = new OrbitControls(camera, renderer.domElement);
  //disable scrollwheel
  controls.enableZoom = false;

  update(renderer, scene, camera, controls);

  function getAmbientLight(intensity) {
    const light = new AmbientLight(0xffffff, intensity);
    return light;
  }
  
  function onMouseMove( event ) {
    mouse.x = ( event.clientX / window.innerWidth ) * 2 - 1;
    mouse.y = - ( event.clientY / window.innerHeight ) * 2 + 1;
    raycaster.setFromCamera( mouse, camera );

    const intersects = raycaster.intersectObjects( scene.children );

    if (intersects[0]){
      container.classList.add("cursor-active");
    } else {
      container.classList.remove("cursor-active")
    }
  }

  function update(renderer, scene, camera, controls) {

    renderer.render(scene, camera);    
    controls.update();
    model.rotation.y = performance.now() / 5000;

    const onWindowResize = () => {
      camera.aspect = container.offsetWidth / container.offsetHeight;
      camera.updateProjectionMatrix();

      renderer.setSize( container.offsetWidth, container.offsetHeight );

    }
    window.addEventListener( 'mousemove', onMouseMove );
    window.addEventListener('resize', onWindowResize );

    requestAnimationFrame(function () {
      update(renderer, scene, camera, controls);
    });
  }

  return scene;
}

const scene = init();